/**
 * Notification center API — reads + clears the current user's notifications.
 */
import type { ItemResponse } from '../../types/api.js';
import { apiRequest } from './core.js';

export interface NotificationDTO {
  id: string;
  type: string;
  title: string;
  message: string;
  metadata: Record<string, unknown> | null;
  read: boolean;
  createdAt: string;
}

export interface NotificationListData {
  items: NotificationDTO[];
  unreadCount: number;
}

export const notificationsApi = {
  list: (limit = 20) =>
    apiRequest<ItemResponse<NotificationListData>>(`/notifications?limit=${limit}`),
  /** Mark specific notifications read, or all of them when `ids` is omitted. */
  markRead: (ids?: string[]) =>
    apiRequest<ItemResponse<{ marked: number }>>('/notifications/read', {
      method: 'POST',
      body: JSON.stringify(ids && ids.length > 0 ? { ids } : {}),
    }),
};
